import Axios from 'axios';
import swal from 'sweetalert';
import environment from '../environments/environment';
import { authService } from '../services/authService';
import { ensureValidToken } from './guestyApiInterceptor';

Axios.interceptors.request.use(
  async (config) => {
    // Skip adding Authorization header for refreshToken API call
    if (config.url.includes(`${environment.pordalNodeApi}/owner/oauth`)) {
      return config;
    }
    if (config.url.includes(environment.pordalNodeApi)) {
      const newToken = await ensureValidToken();
      const token = newToken || authService.getUserToken();
      const tokenData = authService.getPordalConfig();

      config.headers.Authorization = `Bearer ${tokenData?.access_token || token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

Axios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const url = error.config?.url || '';

    const isPordalApi = url.startsWith(environment.pordalNodeApi);
    const isAuthApi = url.includes('/owner/oauth');

    // Handle 401 errors
    if (isPordalApi && error.response?.status === 401) {
      const hasToken = authService.getUserToken();

      // If it's the auth API but we don't have a token, it's a failed login attempt; ignore.
      if (isAuthApi && !hasToken) {
        return Promise.reject(error);
      }

      // If we have a token (or it's not the auth API), show session expired popup.
      if (hasToken) {
        await swal('Your session expired', 'Please login again', 'warning');
        authService.logoutProceed();
        window.location.href = `${window.location.origin}/#/login`;
      }
    }

    return Promise.reject(error);
  }
);
